import { DropResult } from "@hello-pangea/dnd";
import { useCallback } from "react";
import { usePlayground } from "../../playground-store";

interface DragAndDropConfig {
  dragDisabled: boolean;
  handleDragEnd: (result: DropResult) => void;
}

const useMessageDragAndDrop = (): DragAndDropConfig => {
  const playground = usePlayground();
  const dragDisabled =
    playground.readonly || playground.isAIPromptAssistantLoading;

  const handleDragEnd = useCallback(
    (result: DropResult) => {
      if (!result.destination || dragDisabled) return;

      const { source, destination } = result;

      if (
        source.index >= playground.messages.length ||
        destination.index >= playground.messages.length
      ) {
        return;
      }

      if (source.index !== destination.index) {
        playground.reorderMessages(source.index, destination.index);
      }
    },
    [dragDisabled, playground],
  );

  return {
    dragDisabled,
    handleDragEnd,
  };
};

export default useMessageDragAndDrop;
